import React from 'react'

import ApproveModal from '../../../components/approveModal/index'
import { databaseModalsActions } from '../actions'
import { useActions, useAppSelector } from '../../../store/hooks'
import { databasePageSelector } from '../../../store/slices/databasePage'
import { databaseSelector } from '../../../store/slices/database'

const DatabaseModals = () => {
    const showDeleteModal = useAppSelector(databasePageSelector.showDeleteModal)
    const deleteTargetRow = useAppSelector(databasePageSelector.deleteTargetRow)
    const selectedTable = useAppSelector(databasePageSelector.selectedTable)
    const deleting = useAppSelector(databaseSelector.deleting)

    const { setDeleteModal, databaseDeleteRow } = useActions(databaseModalsActions)

    const cancelDelete = () => {
        setDeleteModal({ open: false })
    }

    const confirmDelete = () => {
        if (!deleteTargetRow) return

        databaseDeleteRow({
            table: selectedTable,
            row: deleteTargetRow,
        })

        cancelDelete()
    }

    return (
        <ApproveModal
            title="Удалить запись?"
            text="Вы уверены, что хотите удалить эту запись? Данное действие нельзя будет отменить."
            onClick={confirmDelete}
            onCancel={cancelDelete}
            visible={showDeleteModal}
            confirmLoading={deleting}
        />
    )
}

export default DatabaseModals
